var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006DF3"
    },
    d: "M504.381,448.553c-7.969,11.473-21.059,18.316-35.025,18.316H42.655 c-13.977,0-27.066-6.842-35.035-18.316c-7.969-11.484-9.815-26.149-4.934-39.228l41.053-110.081h424.522l41.053,110.081 C514.196,422.404,512.35,437.069,504.381,448.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005FD1"
    },
    d: "M504.381,448.553c-7.969,11.473-21.059,18.316-35.025,18.316h-210.92V299.244h209.825l41.053,110.081 C514.196,422.404,512.35,437.069,504.381,448.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8E7F9"
    },
    d: "M475.239,45.09v240.803c0,16.01-12.975,28.986-28.986,28.986H66.926 c-16.01,0-28.986-12.975-28.986-28.986V45.09c0-16.01,12.975-28.986,28.986-28.986h379.327 C462.264,16.104,475.239,29.08,475.239,45.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D9F5"
    },
    d: "M475.239,45.09v240.803c0,16.01-12.975,28.986-28.986,28.986H258.436V16.104h187.817 C462.264,16.104,475.239,29.08,475.239,45.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A5FF"
    },
    d: "M446.253,0.459H66.926c-24.605,0-44.631,20.026-44.631,44.631v240.803 c0,24.615,20.026,44.641,44.631,44.641h379.327c24.605,0,44.631-20.026,44.631-44.641V45.09 C490.884,20.485,470.858,0.459,446.253,0.459z M459.593,285.893c0,7.364-5.987,13.351-13.34,13.351H66.926 c-7.353,0-13.34-5.987-13.34-13.351V45.09c0-7.353,5.987-13.34,13.34-13.34h379.327c7.353,0,13.34,5.987,13.34,13.34V285.893z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202.9,
    y: 101.674,
    style: {
      fill: "#FF4F18"
    },
    width: 197.476,
    height: 31.291
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.231,
    y: 164.381,
    style: {
      fill: "#FF4F18"
    },
    width: 287.145,
    height: 31.291
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.231,
    y: 227.098,
    style: {
      fill: "#FF4F18"
    },
    width: 287.145,
    height: 31.291
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8900"
    },
    d: "M285.805,424.271h-60.944c-4.537,0-7.624-4.6-5.914-8.793l8.271-20.245 c0.98-2.399,3.317-3.974,5.904-3.974h44.412c2.597,0,4.934,1.575,5.914,3.974l8.261,20.245 C293.429,419.672,290.342,424.271,285.805,424.271z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.758,
    y: 480.251,
    style: {
      fill: "#006DF3"
    },
    width: 506.076,
    height: 31.291
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.441,
    y: 480.251,
    style: {
      fill: "#005FD1"
    },
    width: 251.4,
    height: 31.291
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.231,
    y: 72.751,
    style: {
      fill: "#FF4F18"
    },
    width: 60.892,
    height: 60.892
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 258.441,
    y: 101.674,
    style: {
      fill: "#FF3400"
    },
    width: 141.935,
    height: 31.291
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.441,
    y: 164.381,
    style: {
      fill: "#FF3400"
    },
    width: 141.935,
    height: 31.291
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.441,
    y: 227.098,
    style: {
      fill: "#FF3400"
    },
    width: 141.935,
    height: 31.291
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0082D2"
    },
    d: "M490.884,45.09v240.803c0,24.615-20.026,44.641-44.631,44.641H258.436v-31.291h187.817 c7.353,0,13.34-5.987,13.34-13.351V45.09c0-7.353-5.987-13.34-13.34-13.34H258.436V0.459h187.817 C470.858,0.459,490.884,20.485,490.884,45.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E57500"
    },
    d: "M285.805,424.271h-27.369V391.26h19.098c2.597,0,4.934,1.575,5.914,3.974l8.261,20.245 C293.429,419.672,290.342,424.271,285.805,424.271z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopComputer);
export default __webpack_public_path__ + "static/media/laptop-computer.a8436efc0e12b8fd67575aa2deb03ea0.svg";
export { ForwardRef as ReactComponent };